import type { ComponentProps } from "react"

export default function TransactionEstateSettlement(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M16.3125 3.9375H1.6875C1.38924 3.93784 1.10329 4.05648 0.892382 4.26738C0.681477 4.47829 0.562841 4.76424 0.5625 5.0625V12.9375C0.562841 13.2358 0.681477 13.5217 0.892382 13.7326C1.10329 13.9435 1.38924 14.0622 1.6875 14.0625H16.3125C16.6108 14.0622 16.8967 13.9435 17.1076 13.7326C17.3185 13.5217 17.4372 13.2358 17.4375 12.9375V5.0625C17.4372 4.76424 17.3185 4.47829 17.1076 4.26738C16.8967 4.05648 16.6108 3.93784 16.3125 3.9375ZM5.27059 12.9375L1.6875 9.86629V8.13371L5.27059 5.0625H12.7294L16.3128 8.13393L16.3129 9.86593L12.7294 12.9375H5.27059ZM11.8125 9C11.8125 9.55626 11.6475 10.1 11.3385 10.5625C11.0295 11.0251 10.5902 11.3855 10.0763 11.5984C9.56238 11.8113 8.99688 11.867 8.45131 11.7585C7.90574 11.6499 7.4046 11.3821 7.01126 10.9887C6.61793 10.5954 6.35006 10.0943 6.24154 9.54869C6.13302 9.00312 6.18872 8.43762 6.40159 7.9237C6.61446 7.40979 6.97495 6.97053 7.43746 6.66149C7.89997 6.35245 8.44374 6.1875 9 6.1875C9.74566 6.18835 10.4605 6.48494 10.9878 7.0122C11.5151 7.53946 11.8116 8.25434 11.8125 9Z"
        fill={fill}
      />
    </svg>
  )
}
